/* eslint-disable camelcase */
/* eslint-disable ordered-imports/ordered-imports */
/* eslint-disable spire/fenced-imports */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { SortBy, SortByFieldsFields, SortCriterion } from "@coveo/headless/commerce";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIColors from "@NA/Utils/ADIColors";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { withCoveoHooks, HasCoveoHooks } from "@NA/Components/Coveo/Contexts/CoveoHooksContext";

const mapStateToProps = (state: CustomApplicationState) => ({
    isAuth: state.context.session.isAuthenticated,
});

export interface ProductListSortSelectStyles {
    select?: SelectPresentationProps;
    sortByStyles?: InjectableCss;
}

export const sortSelectStyles: ProductListSortSelectStyles = {
    select: {
        labelProps: {
            css: css`
                width: unset;
            `,
        },
        cssOverrides: {
            formField: css`
                width: 325px;
            `,
        },
    },
    sortByStyles: {
        css: css`
            display: inline-flex;
            ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        margin-left: 15px;
                    `,
                    null,
                    null,
                ])}
            > label {
                padding-right: 11px;
                display: inline-flex;
                align-items: center;
                color: ${ADIColors.darkBlack3};
                font-size: 14px;
                font-weight: 800;
                ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    css`
                            width: 62px;
                        `,
                    css`
                            width: 62px;
                        `,
                    null,
                    null,
                    null,
                ])}
            }
            > div[class^="FormFieldStyle"] {
                width: 185px;
                margin-right: 20px;
                @media (min-width: 375px) and (max-width: 1079px) {
                    margin-right: 0;
                }
                ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    css`
                            width: auto;
                        `,
                    css`
                            width: auto;
                        `,
                    null,
                    null,
                    null,
                ])}
                > div:first-of-type {
                    width: 0 !important;
                }
                > div[class^="FormInputWrapper"] {
                    > select {
                        width: 164px;
                        ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    css`
                                    width: 112px !important;
                                    padding-right: 10px !important;
                                    padding-left: 10px !important;
                                `,
                    css`
                                    width: 112px !important;
                                    padding-right: 10px !important;
                                    padding-left: 10px !important;
                                `,
                    null,
                    null,
                    null,
                ])}
                    }
                    > span {
                        left: 120px;
                        ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    css`
                                    left: 82px;
                                `,
                    css`
                                    left: 82px;
                                `,
                    null,
                    null,
                    null,
                ])}
                    }
                }
            }
        `,
    },
};

const styles = sortSelectStyles;

interface OwnProps extends WidgetProps { }

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasCoveoHooks;

const CoveoSortComponent: React.FC<Props> = ({
    isAuth,
    sort
}) => {
    const getSortLabel = (criterion: SortCriterion) => {
        switch (criterion.by) {
            case SortBy.Relevance:
                return 'Best Match';
            case SortBy.Fields:
                return criterion.fields.map((field: SortByFieldsFields) => field.displayName).join(', ');
        }
    };

    const { state: sortState, methods: sortMethods } = sort;

    return (
        <StyledWrapper {...styles.sortByStyles}> 
            <label htmlFor="pagerSortTypeSelector">Sort by</label>
            <Select
                {...styles.select}
                labelPosition="left"
                id="coveoPagerSortTypeSelector"
                onChange={(e) => sortMethods?.sortBy(JSON.parse(e.target.value))}
                value={JSON.stringify(sortState?.appliedSort)}
            >
                {sortState?.availableSorts?.map((sortCriteria: SortCriterion, i: number) => {
                    const isPriceSort = (sortCriteria.by === SortBy.Fields) && sortCriteria.fields.some((field: SortByFieldsFields) => field.displayName?.toLowerCase().includes('price'));
                    if (isPriceSort) { return null; }
                    return (
                        <option
                            key={i}
                            value={JSON.stringify(sortCriteria)}
                            onSelect={() => sortMethods?.sortBy(sortCriteria)}
                        >
                            {getSortLabel(sortCriteria)}
                        </option>
                    );
                })}
            </Select>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withCoveoHooks(CoveoSortComponent)),
    definition: {
        group: "Product List",
        displayName: "Coveo Sort Select",
    },
};

export default widgetModule;
